import { createStore } from 'vuex';

import loginModule from '@/modules/login/shared/store';
import dataModule from './modules/data';
import httpModule from './modules/http';
import signModule from '@/modules/consent/modules/SignaturePage/store';
import actions from './actions';
import mutations from './mutations';
import getters from './getters';

import { DEFAULT_DIRECTION } from '@/modules/login/shared/store/constants';

export default createStore({
  state: {
    registeredModules: [],
    locale: 'en',
    direction: DEFAULT_DIRECTION,
    hideIgentifyLogo: true,
    isLoggedIn: false,
    supportsLandscapeWarning: false,
  },
  mutations,
  actions,
  getters,
  modules: {
    dataModule,
    loginModule,
    httpModule,
    signModule,
  },
});
